<div class="wrapper pt-10 md:pt-14 relative min-h-10">
  @if (isReloading()) {
    <korviu-loader></korviu-loader>
  }
  @if (isLoading()) {
    <div class="relative min-h-10">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (!accounts?.length) {
    <korviu-no-data size="large" />
  } @else {
    <div class="summary-list flex flex-col gap-4 md:gap-6 relative">
      @for (account of accounts; track account.id) {
        <div class="summary-list-item">
          <div class="flex flex-row gap-2 md:gap-4 items-center name-status">
            <span class="name font-medium text-base md:text-lg">
              {{ account?.bank_information?.bank_name?.value || 'Bank name' }}
            </span>
            @if (getAccountStatus(account)) {
              <app-tag [type]="getAccountStatus(account)?.type">
                {{ getAccountStatus(account)?.localizableName | translate }}
              </app-tag>
            }
          </div>
          <div class="flex flex-row items-center gap-2">
            <span class="last-digits text-base md:text-lg">{{
              account?.bank_information?.account_number?.value ?? account?.bank_information?.clabe_number?.value | mask
            }}</span>
            <button
              nz-button
              nzType="text"
              nz-popconfirm
              appHideTooltipOnScroll
              [nzIcon]="null"
              nzPopconfirmPlacement="bottomRight"
              nzPopconfirmArrowPointAtCenter
              [nzPopconfirmOverlayClassName]="'action-menu-popconfirm-overlay'"
              [nzPopconfirmTitle]="accountActions"
            >
              <i nz-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path
                    d="M12.25 7.5C11.2835 7.5 10.5 6.7165 10.5 5.75C10.5 4.7835 11.2835 4 12.25 4C13.2165 4 14 4.7835 14 5.75C14 6.7165 13.2165 7.5 12.25 7.5ZM12.25 13.5C11.2835 13.5 10.5 12.7165 10.5 11.75C10.5 10.7835 11.2835 10 12.25 10C13.2165 10 14 10.7835 14 11.75C14 12.7165 13.2165 13.5 12.25 13.5ZM10.5 17.75C10.5 18.7165 11.2835 19.5 12.25 19.5C13.2165 19.5 14 18.7165 14 17.75C14 16.7835 13.2165 16 12.25 16C11.2835 16 10.5 16.7835 10.5 17.75Z"
                    fill="#505760"
                  />
                </svg>
              </i>
            </button>
            <ng-template #accountActions>
              <div class="action-menu-popconfirm">
                @if (canBeSetByDefault(account)) {
                  <button nz-button nzType="text" class="p-0" (click)="onSetAsDefaultCLick(account?.id)">
                    <div class="flex flex-row gap-2">
                      <i nz-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                          <path
                            d="M12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5ZM12 4C7.30558 4 3.5 7.80558 3.5 12.5C3.5 17.1944 7.30558 21 12 21C16.6944 21 20.5 17.1944 20.5 12.5C20.5 7.80558 16.6944 4 12 4ZM10.75 13.9393L15.2197 9.46967C15.5126 9.17678 15.9874 9.17678 16.2803 9.46967C16.5466 9.73594 16.5708 10.1526 16.3529 10.4462L16.2803 10.5303L11.2803 15.5303C11.0141 15.7966 10.5974 15.8208 10.3038 15.6029L10.2197 15.5303L7.71967 13.0303C7.42678 12.7374 7.42678 12.2626 7.71967 11.9697C7.98594 11.7034 8.4026 11.6792 8.69621 11.8971L8.78033 11.9697L10.75 13.9393Z"
                            fill="#2C3035"
                          />
                        </svg>
                      </i>
                      <span class="font-medium text-base">{{ 'profile.setAsDefault' | translate }}</span>
                    </div>
                  </button>
                }
                <button nz-button nzType="text" class="p-0" (click)="onDetailsCLick(account?.id)">
                  <div class="flex flex-row gap-2">
                    <i nz-icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path
                          d="M11.9984 9.50462C14.2075 9.50462 15.9984 11.2955 15.9984 13.5046C15.9984 15.7138 14.2075 17.5046 11.9984 17.5046C9.78926 17.5046 7.9984 15.7138 7.9984 13.5046C7.9984 11.2955 9.78926 9.50462 11.9984 9.50462ZM11.9984 11.0046C10.6177 11.0046 9.4984 12.1239 9.4984 13.5046C9.4984 14.8853 10.6177 16.0046 11.9984 16.0046C13.3791 16.0046 14.4984 14.8853 14.4984 13.5046C14.4984 12.1239 13.3791 11.0046 11.9984 11.0046ZM11.9984 6C16.6119 6 20.5945 9.15001 21.6995 13.5644C21.8001 13.9662 21.5559 14.3735 21.1541 14.4741C20.7522 14.5746 20.345 14.3305 20.2444 13.9286C19.3055 10.178 15.9197 7.5 11.9984 7.5C8.07534 7.5 4.6885 10.1803 3.75126 13.9332C3.6509 14.335 3.24376 14.5794 2.84189 14.4791C2.44002 14.3787 2.1956 13.9716 2.29596 13.5697C3.39905 9.15272 7.38289 6 11.9984 6Z"
                          fill="#2C3035"
                        />
                      </svg>
                    </i>
                    <span class="font-medium text-base">{{ 'profile.seeDetails' | translate }}</span>
                  </div>
                </button>
                <button
                  nz-button
                  nzType="text"
                  class="p-0 action-menu-popconfirm__danger"
                  (click)="onRemoveCLick(account?.id, account?.default)"
                >
                  <div class="flex flex-row gap-2">
                    <i nz-icon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path
                          d="M10 5.5H14C14 4.39543 13.1046 3.5 12 3.5C10.8954 3.5 10 4.39543 10 5.5ZM8.5 5.5C8.5 3.567 10.067 2 12 2C13.933 2 15.5 3.567 15.5 5.5H21.25C21.6642 5.5 22 5.83579 22 6.25C22 6.66421 21.6642 7 21.25 7H19.9309L18.7589 19.1112C18.5729 21.0334 16.9575 22.5 15.0263 22.5H8.97369C7.04254 22.5 5.42715 21.0334 5.24113 19.1112L4.06908 7H2.75C2.33579 7 2 6.66421 2 6.25C2 5.83579 2.33579 5.5 2.75 5.5H8.5ZM10.5 10.25C10.5 9.83579 10.1642 9.5 9.75 9.5C9.33579 9.5 9 9.83579 9 10.25V17.75C9 18.1642 9.33579 18.5 9.75 18.5C10.1642 18.5 10.5 18.1642 10.5 17.75V10.25ZM14.25 9.5C14.6642 9.5 15 9.83579 15 10.25V17.75C15 18.1642 14.6642 18.5 14.25 18.5C13.8358 18.5 13.5 18.1642 13.5 17.75V10.25C13.5 9.83579 13.8358 9.5 14.25 9.5ZM6.73416 18.9667C6.84577 20.12 7.815 21 8.97369 21H15.0263C16.185 21 17.1542 20.12 17.2658 18.9667L18.4239 7H5.57608L6.73416 18.9667Z"
                          fill="#CB2222"
                        />
                      </svg>
                    </i>
                    <span class="font-medium text-base">{{ 'profile.remove' | translate }}</span>
                  </div>
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      }
    </div>
  }
</div>
<div class="buttons w-full mt-12 md:mt-16">
  <korviu-button color="tertiary" (onclick)="onAddAccountClick()">
    {{ 'profile.addAccountButton' | translate }}
  </korviu-button>
</div>
